// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OccupancyCabinClass-module__wrapper___TVUXB"};